export default __webpack_public_path__ + "c0278eddf8d8f53ad00e0a96b3d676be.png";